import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';

export default {
  install(Vue, options) {
    if (!options.hasOwnProperty('getSession') || !options.hasOwnProperty('apiUrl')) {
      this.$log.error(
        'CactusGraphql::install() => CactusGraphql requires a valid getSession promise and apiUrl'
      );
      return;
    }

    const customFetch = (uri, opt) => {
      this.refreshingPromise = null;

      var initialRequest = fetch(uri, opt);

      return initialRequest
        .then(response => {
          return response.json();
        })
        .then(json => {
          /**
           * If a user has selected a device on a certain stage and then
           * switches to another stage, we get an AuthorizationDeniedError.
           * In order to recover from this state, we have to delete the localStorage
           * and refresh the page.
           */
          if (
            json &&
            json.errors &&
            json.errors[0] &&
            json.errors[0].name === 'AuthorizationDeniedError'
          ) {
            window.localStorage.clear();
            location.reload();
          }
          return fetch(uri, opt);
        });
    };

    const httpLink = createHttpLink({
      uri: options.apiUrl,
      fetch: customFetch
    });

    const authMiddleware = setContext(() =>
      options.getSession().then(token => {
        return {
          // Make sure to actually set the headers here
          headers: {
            authorization: ((token || {}).idToken || {}).jwtToken || null
          }
        };
      })
    );

    let client = new ApolloClient({
      link: authMiddleware.concat(httpLink),
      cache: new InMemoryCache()
    });

    Vue.prototype.$graphqlClient = client;
    return client;
  }
};
